<script setup lang="ts">
import stores from '@jaaluu/stores';

const { langNative, langForeign, langOptions } = stores.language.state;

</script>

<template>
  <div>
    <div class="d-flex align-center justify-end grab ">
      <div class="flag-wrapper ml-2">
        <v-img
          :src="langOptions.find((o) => o.value === langForeign)?.flag"
          alt=""
          class="flag-icon"
        />
      </div>
      <v-icon icon="mdi-arrow-right-thin" size="12" />
      <div class="flag-wrapper">
        <v-img
          :src="langOptions.find((o) => o.value === langNative)?.flag"
          alt=""
          class="flag-icon"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.flag-icon {
  width: 20px;
}
</style>
